"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = _interopRequireDefault(require("./styles"));
var _Highlight = require("../../contexts/Highlight");
var _PdfReader = _interopRequireDefault(require("../../services/PdfReader"));
var _core = require("@material-ui/core");
var _HighlightListItem = _interopRequireDefault(require("../HighlightListItem"));
var _HighlightList = require("../../contexts/HighlightList");
var _utils = require("../../utils");
var _Auth = require("../../contexts/Auth");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function HighlightsList(_ref) {
  var {
    pdf,
    setOpenDrawer,
    handleCopyButtonClick
  } = _ref;
  var classes = (0, _styles.default)();
  var {
    highlights
  } = (0, _Highlight.useHighlight)();
  var [newHighlights, setNewHighlights] = (0, _react.useState)([]);
  var {
    focus,
    setFocus
  } = (0, _HighlightList.useHighlightList)();
  var {
    auth
  } = (0, _Auth.useAuth)();
  var containerRef = (0, _react.useRef)();
  var annotationRef = (0, _react.useRef)();
  var {
    bookTitle
  } = auth;
  (0, _react.useEffect)(() => {
    function loadHighlights() {
      return _loadHighlights.apply(this, arguments);
    }
    function _loadHighlights() {
      _loadHighlights = _asyncToGenerator(function* () {
        var title = yield _PdfReader.default.getBookTitle(pdf);
        var promise = highlights.map(item => _PdfReader.default.getOutlineByPage(pdf, item.text_reference.position.pageNumber));
        var outlines = yield Promise.all(promise);
        var values = outlines.map((item, i) => _objectSpread(_objectSpread({}, highlights[i]), {}, {
          title: (item === null || item === void 0 ? void 0 : item.title) || title || bookTitle
        }));
        setNewHighlights(values);
      });
      return _loadHighlights.apply(this, arguments);
    }
    loadHighlights();
  }, [pdf, highlights, bookTitle]);
  (0, _react.useEffect)(() => {
    if (focus && containerRef.current && annotationRef.current) {
      containerRef.current[focus.id].scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center'
      });
      annotationRef.current[focus.id].focus();
      annotationRef.current[focus.id].click();
      setFocus();
    }
  }, [focus, newHighlights, setFocus]);
  function onClickHighlight() {
    if ((0, _utils.getDeviceType)() !== 'desktop') setOpenDrawer(false);
  }
  function renderNoHighlights() {
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      className: classes.placeholder
    }, "Voc\xEA ainda n\xE3o possui nenhuma marca\xE7\xE3o.");
  }
  function renderHighlightItem(highlight) {
    var onContainerRef = el => containerRef.current = _objectSpread(_objectSpread({}, containerRef.current), {}, {
      [highlight.id]: el
    });
    var onAnnotationRef = el => annotationRef.current = _objectSpread(_objectSpread({}, annotationRef.current), {}, {
      [highlight.id]: el
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      key: highlight.id,
      ref: onContainerRef
    }, /*#__PURE__*/_react.default.createElement(_HighlightListItem.default, {
      highlight: highlight,
      annotationRef: onAnnotationRef,
      onClickHighlight: onClickHighlight,
      handleCopyButtonClick: handleCopyButtonClick
    }), /*#__PURE__*/_react.default.createElement(_core.Divider, null));
  }
  if (!newHighlights.length) return renderNoHighlights();
  return /*#__PURE__*/_react.default.createElement(_core.List, null, newHighlights.map(renderHighlightItem));
}
var _default = exports.default = HighlightsList;